import { render, staticRenderFns } from "./FilterColors.vue?vue&type=template&id=22f052c8&scoped=true"
import script from "./FilterColors.vue?vue&type=script&lang=js"
export * from "./FilterColors.vue?vue&type=script&lang=js"
import style0 from "./FilterColors.vue?vue&type=style&index=0&id=22f052c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f052c8",
  null
  
)

export default component.exports